import React, { Component } from 'react'

export default class GeneratedTable extends Component {
    render() {
        return <div>GENERATED TABLE</div>
    }
}
